"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MapInventory_exports = {};
__export(MapInventory_exports, {
  MapInventory: () => MapInventory,
  mapInventory: () => mapInventory
});
module.exports = __toCommonJS(MapInventory_exports);
var import_fp = require("@cartographerio/fp");
var import_topo_map = require("@cartographerio/topo-map");
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
var import_lodash = require("lodash");
var import_baseStyles = require("./core/baseStyles.js");
class MapInventory {
  constructor(maps) {
    /** Returns a list of all survey maps. */
    this.maps = () => {
      return this._maps;
    };
    this.allLayers = () => (0, import_lodash.uniqBy)(
      Object.values(this.maps()).flatMap((map) => map.layers),
      (layer) => layer.layerId
    );
    this.unsafeMapFromLayerIds = (layerIds, mapId = (0, import_types.unsafeMapId)("custom")) => {
      const layers = this.allLayers();
      return (0, import_topo_map.mapSchema)({
        mapId,
        title: "Combined",
        baseStyles: import_baseStyles.baseStyles,
        defaultBase: import_types.MapBaseEnum.Terrain,
        layers: (0, import_util.filterAndMap)(layerIds, (layerId) => layers.find((layer) => layer.layerId === layerId))
      });
    };
    this.unsafeKitchenSinkMap = (mapId = (0, import_types.unsafeMapId)("custom")) => {
      return (0, import_topo_map.mapSchema)({
        mapId,
        title: "Cartographer",
        baseStyles: import_baseStyles.baseStyles,
        defaultBase: import_types.MapBaseEnum.Terrain,
        layers: this.allLayers()
      });
    };
    /** Returns a list of all survey map IDs. */
    this.mapIds = () => {
      return this._maps.map((map) => map.mapId);
    };
    /** Returns a Map given an ID. */
    this.mapById = (id) => {
      return import_fp.Option.wrap(this._mapsById[id]);
    };
    this._maps = maps;
    this._mapsById = Object.fromEntries(maps.map((map) => [map.mapId, map]));
  }
}
function mapInventory(maps) {
  return new MapInventory(maps);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  MapInventory,
  mapInventory
});
//# sourceMappingURL=MapInventory.js.map
